import { render, staticRenderFns } from "./O2DHTML.vue?vue&type=template&id=38c70909&"
import script from "./O2DHTML.vue?vue&type=script&lang=js&"
export * from "./O2DHTML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports